import { api } from './api';

export const grievanceService = {
    getGrievances: async (pageNumber = 1, pageSize = 10, search = '') => {
        return api.get(`/grievance-types?PageNumber=${pageNumber}&PageSize=${pageSize}&Search=${search}`);
    },

    getAllGrievances: async (pageNumber = 1, pageSize = 10, search = '') => {
        return api.get(`/Grievance/grievances/all?PageNumber=${pageNumber}&PageSize=${pageSize}&Search=${search}`);
    },

    getGrievanceById: async (id) => {
        return api.get(`/grievance-types/${id}`);
    },

    /**
     * Creates a new grievance.
     */
    addGrievance: async (grievanceName) => {
        return api.post('/grievance-types', { grievanceName });
    },

    /**
     * Update grievance.
     */
    updateGrievance: async (id, grievanceName) => {
        return api.post(`/grievance-types/${id}`, { grievanceName });
    },

    /**
     * Deletes a grievance .
     */
    deleteGrievance: async (id) => {
        return api.delete(`/grievance-types/${id}`);
    },

    /**
     * Deletes .
     */
    deleteUserGrievance: async (id) => {
        return api.delete(`/Grievance/grievances/${id}`);
    },

    /**
     * Submits a new grievance .
     */
    submitGrievance: async (data) => {
        console.log('Submitting Grievance Payload:', JSON.stringify(data, null, 2)); // DEBUG LOG
        const formData = new FormData();
        formData.append('userId', data.userId);
        formData.append('grievanceTypeId', String(data.grievanceTypeId));
        formData.append('constituencyId', String(data.constituencyId));
        formData.append('address', data.address);
        formData.append('description', data.description);

        if (data.proofPic) {
            const file = {
                uri: data.proofPic.uri,
                type: data.proofPic.type || 'image/jpeg',
                name: data.proofPic.name || 'proof.jpg',
            };
            formData.append('proofPic', file);
        }

        return api.post('/Grievance/grievances', formData);
    },

    /**
     * Updates the status of a user grievance (petition) with remarks.
     */
    updateUserGrievanceStatus: async (grievanceId, status, remarks) => {
        return api.post(`/Grievance/grievances/status/${grievanceId}`, { status, remarks });
    }



};
